import { useEffect, useState } from "react";
import { CommonDropDownService } from "../../service/CommonDropDownService";
import Layout from "../../Layout/Layout";
import { AuthService } from "../../service/AuthService";
import EventService from "../../service/EventService";
import { useSearchParams, useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import Backdrop from '@mui/material/Backdrop';
import Loader from "../Loader";
import { isEditable } from "@testing-library/user-event/dist/utils";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import NearMeIcon from '@mui/icons-material/NearMe';

function AddOrEditEventForm() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [country, setCountry] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState([]);
    const [errors, setErrors] = useState({});
    const [eventDescription, setEventDescription] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [appType, setAppType]= useState(0)
    const [openLoader, setopenLoader] =useState(false);

    const getCountryList = async (value) => {
        try {
            const response = await CommonDropDownService.getCountry();
            response ? setCountry(response) : setCountry([]);
            if (value && response) {
                response.filter(function (f) {
                    if (parseInt(f.value) === value) {
                        var ddData = { label: f.label, value: f.value };
                        setSelectedCountry(ddData);
                    }
                })
            }
        } catch (error) {

        }
    }
    const handleCountry = (e) => {
        if (e) {
            setSelectedCountry(e);
        }
    }
    // function for handling form submission
    const handleRegister = async (e) => {
        try {
            e.preventDefault();
            // Collect form data
            const formData = new FormData(e.target);
            const data = Object.fromEntries(formData);
            const newErrors = {};
            if (!data.eventDes) newErrors.eventDes = 'Event description is required';
            if (!data.start_date) newErrors.start_date = 'Start date is required';
            if (!data.end_date) newErrors.end_date = 'End date is required';
            if (!data.country_input) newErrors.country = 'Country is required';
            if(!data.inline_radio_group) newErrors.inline_radio_group = 'App type is required';
            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }   
            
            setErrors({});
            const formdata = {
                EventID: getParams() ? getParams() : "",
                CreatedBy: AuthService.getCurrentUser().userId,
                Country: parseInt(selectedCountry.value),
                EventDescription: data.eventDes,
                StartDate: data.start_date,
                EndDate: data.end_date,
                AppType: data.inline_radio_group
            }

            if (validateDates()) {

                const response = await EventService.AddOrUpdateEvent(formdata);
                if (response.isSuccess) {

                    alert(response.message);
                    e.target.reset();
                    // console.log(e.target);
                    setSelectedCountry(null);
                    setEventDescription("")
                    setStartDate("")
                    setEndDate("")
                    setAppType(0)
                    setErrors({});
                    navigate('/eventlist')
                }
                else {
                    alert(response.message);
                }
            }
        } catch (error) {
            console.log(error)
        }
    };
    const validateDates = () => {
        // var startDate = new Date(document.getElementById("start_date").value);
        // var endDate = new Date(document.getElementById("end_date").value);
        var startDate = document.getElementById("start_date").value
        var endDate = document.getElementById("end_date").value;

        var currentDate= new Date();
        currentDate= dateExtraction(currentDate)
        // console.log(currentDate);
        // console.log("endDate",document.getElementById("end_date").value)
        if (endDate < startDate) {
            alert("End date must be greater than or equal to start date.");
            return false;
        } 
        else if(startDate<currentDate){
            alert("Start date must be greater than current date.");
            return false;
        }
        return true;
    }
    const getParams = () => {
        const param = searchParams.get("id");
        return param;
    }
    const initEventListByID = async () => {
        try {
            setopenLoader(true)
            const res = await EventService.GetEventListById(getParams());
            const data = JSON.parse(res.apiData);
            handleSetReceivedData(data);
            setopenLoader(false)
        } catch (error) {
            setopenLoader(false)
        }
    }
    function handleSetReceivedData(data) {

        let cID=data[0].CountryID;
        getCountryList(cID);
        setEventDescription(data[0].Description)
        setStartDate(dateFormating(data[0].StartDate))
        setEndDate(dateFormating(data[0].EndDate))
        setAppType(data[0].AppType);
    }

    function dateFormating(date){
        const day= date.slice(0,2);
        const month= date.slice(3,5);
        const year= date.slice(6,10);

        let dateString="";
        dateString+=year+'-';
        dateString+= month+'-';
        dateString+= day;
        return dateString;
    }

    function dateExtraction(date){
        let day= date.getDate();
        let month= date.getMonth()+1;
        let year= date.getFullYear();

        let dateString="";
        dateString+=year+'-';
        dateString+= (month>9?month:"0"+month)+'-';
        dateString+= (day>9?day:"0"+ day);
        return dateString;
    }

    function handleStartDate(e){
        setStartDate(e.target.value);
        const date= e.target.value;
        console.log("date", date);
        document.getElementById("end_date").setAttribute('min', date);
    }


    useEffect(() => {
        if (!(AuthService.isAuthenticatedUser())) {
            navigate('/');
        }
    }, [])
    
    useEffect(() => {
        initEventListByID();
        getCountryList()
    }, []);

    useEffect(()=>{
        if(selectedCountry){
            setErrors(prevErrors => {
                return {...prevErrors, country: null};
              });
        }
        if(eventDescription){
            setErrors(prevErrors => {
                return {...prevErrors, eventDes: null};
              });
        }
        if(startDate){
            setErrors(prevErrors => {
                return {...prevErrors, start_date: null};
              });
        }
        if(endDate){
            setErrors(prevErrors => {
                return {...prevErrors, end_date: null};
              });
        }
        if(appType){
            setErrors(prevErrors => {
                return {...prevErrors, inline_radio_group: null};
              });
        }
},[selectedCountry,eventDescription,startDate,endDate,appType])


    return (
        <>
         <Backdrop
                sx={{ color: '#FF5C35', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openLoader} >
                    <Loader/>
            </Backdrop>
            <Layout>
                <div className="container w-full h-full mb-2 max-sm:-mt-12 sm:mt-10">
                    <div className="flex flex-col relative  justify-center items-center gap-2 w-full h-full">
                        <h1 className="font-sans text-orange-600 font-bold text-2xl sm:text-4xl mt-8">Add/Update Event</h1>
                        <button onClick={()=>navigate('/eventlist')} className="sm:py-2 p-1 max-sm:text-[16px] sm:px-3 absolute top-24 right-2 border border-orange-400 rounded-xl bg-orange-500 font-semibold text-white hover:bg-orange-600"><FormatListBulletedIcon className="mr-1"/>Event List</button>
                        
                        <form id="form" onSubmit={handleRegister} className="shadow-sm relative shadow-gray-800 rounded-xl border-t-[1px] border sm:w-1/2 w-11/12 flex flex-col gap-2 px-8 py-2">
                        

                            {/* country field */}
                            <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">Country:</label>
                                
                                <ReactSelect
                                value={selectedCountry}
                                name="country_input"
                                className="w-4/5 h-10 outline-none rounded-md"
                                onChange={(e) => handleCountry(e)}
                                options={country}
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? 'orange' : 'black',
                                        boxShadow: state.isFocused ? '0 0 0 1px orange' : 'none',
                                        '&:hover': {
                                          borderColor: 'orange',
                                        },
                                      }),
                                    input: (base) => ({
                                      ...base,
                                      'input:focus': {
                                        boxShadow: 'none',
                                      },
                                    }),
                                  }}
                                />
                                {
                                    errors.country ? <p className="text-red-500">{errors.country}</p>:""
                                }
                            </div>

                            {/* Event description */}
                            <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">Event description:</label>
                                <input value={eventDescription} onChange={(e) => setEventDescription(e.target.value)} name="eventDes" className="w-4/5 h-8 outline-none focus:outline-orange-500 focus:border-none border border-black px-2 py-1 rounded-md" placeholder="Description..." />
                                {
                                    errors.eventDes && <p className="text-red-500">{errors.eventDes}</p>
                                }
                            </div>

                            {/* start date */}
                            <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">Start date:</label>
                                <input pattern="\d{4}/\d{1,2}/\d{1,2}" value={startDate} onChange={(e) => handleStartDate(e)} name="start_date" id="start_date" type="date" className="w-4/5 h-8 border focus:outline-orange-500 focus:border-none border-black px-2 outline-none rounded-md font-semibold" />
                                {
                                    //   pattern="\d{4}-\d{2}-\d{2}"
                                    errors.start_date && <p className="text-red-500">{errors.start_date}</p>
                                }
                            </div>

                            {/* End date  */}
                            <div className="flex flex-col gap-1 items-start">
                                <label className="text-lg font-semibold">End date:</label>
                                <input value={endDate} pattern="\d{4}/\d{1,2}/\d{1,2}" onChange={(e) => setEndDate(e.target.value)} name="end_date" id="end_date" type="date" className="w-4/5 h-8 border focus:outline-none focus:border-orange-500 border-black px-2 rounded-md font-semibold" disabled={!startDate}/>
                                {
                                    errors.end_date && <p className="text-red-500">{errors.end_date}</p>
                                }
                            </div>

                            {/* App type radio buttons */}
                            <div className="flex mt-3 w-full flex-col gap-2">
                                <label className="text-lg font-semibold">App Type:</label>
                                <div className="flex ">
                                <div className="flex items-center me-4 ">
                                    <input id="inline-radio" type="radio" value='1'
                                    checked={appType == 1} 
                                    onChange={(e) =>setAppType(e.target.value)}
                                     name="inline_radio_group" className="w-4 h-4 text-blue-600 bg-gray-400 ring-gray-800 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />

                                    <label htmlFor="inline-radio" className="ms-2 text-[16px] font-medium text-gray-900 dark:text-gray-300 ">Mobile</label>
                                </div>
                                <div className="flex items-center me-4">
                                    <input id="inline-2-radio" type="radio" value='2'
                                     checked={appType == 2}
                                     onChange={(e) => setAppType(e.target.value)}
                                     name="inline_radio_group" className="w-4 h-4 text-blue-600 bg-gray-400 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                    <label htmlFor="inline-2-radio" className="ms-2 text-[16px] font-medium text-gray-900 dark:text-gray-300">Web</label>
                                </div>
                                <div className="flex items-center me-4">
                                    <input id="inline-checked-radio" type="radio" value='3' 
                                    checked={appType == 3}
                                    onChange={(e) => setAppType(e.target.value)}
                                    name="inline_radio_group" className="w-4 h-4 text-blue-600 bg-gray-400 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                    <label htmlFor="inline-checked-radio" className="ms-2 text-[16px] font-medium text-gray-900 dark:text-gray-300">All</label>
                                </div>
                                </div>
                                
                            </div>
                            {
                                    errors.inline_radio_group && <p className="text-red-500">{errors.inline_radio_group}</p>
                                }
                            {/* Submit button */}
                            <button type="submit" className="border border-orange-500 w-32 hover:bg-orange-600 bg-orange-500 text-white py-2 mt-5 rounded-md"><NearMeIcon className="mr-2"/>Submit</button>

                        </form>
                    </div>
                </div>

            </Layout>
        </>
    )
}

export default AddOrEditEventForm;


// Event/AddOrUpdateEvent

//         public int EventID { get; set; }
//         public int Country { get; set; }
//         public string? EventDescription { get; set; }
//         public string StartDate { get; set; }
//         public string EndDate { get; set; }
//         public string CreatedBy { get; set; }
//         public string PageIndex { get; set; }
//         public string PageSize { get; set; }
//         public string Filter { get; set; }

